/**
 * As worn by highlight reel — horizontal snap scroller with prev/next.
 * Progressive enhancement: the track remains a native scroller without JS.
 */
(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    const track = root.querySelector('[data-reel-track]');
    if (!track) return;
    const frames = [...root.querySelectorAll('[data-reel-frame]')];
    const prevButton = root.querySelector('[data-reel-prev]');
    const nextButton = root.querySelector('[data-reel-next]');
    if (frames.length < 2) {
      if (prevButton) prevButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
      return;
    }

    const step = () => {
      const first = frames[0];
      const item = first && first.parentElement;
      if (!item) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    };

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const setButtons = () => {
      const left = track.scrollLeft;
      if (prevButton) prevButton.disabled = left <= 4;
      if (nextButton) nextButton.disabled = left >= maxScroll() - 4;
    };

    const go = (direction) => {
      track.scrollBy({ left: direction * step(), behavior: prefersReduced.matches ? 'auto' : 'smooth' });
    };

    if (prevButton) prevButton.addEventListener('click', () => go(-1));
    if (nextButton) nextButton.addEventListener('click', () => go(1));
    track.addEventListener('scroll', setButtons, { passive: true });
    window.addEventListener('resize', setButtons);
    setButtons();

    if (prefersReduced.matches) return;

    let timer = null;
    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };
    const start = () => {
      stop();
      timer = window.setInterval(() => {
        if (track.scrollLeft >= maxScroll() - 8) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          go(1);
        }
      }, 4200);
    };

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  };

  const boot = () => {
    document.querySelectorAll('[data-as-worn-reel]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
